module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bhTx3"))).then(() => parcelRequire('hEqeo'));